// Auto-submit the type filter when a type is chosen.
//
// The app-wide `.select-auto-submit` handler in global.js binds directly on document ready, so it
// never sees this select - the component loads into its Turbo Frame after that has already run.
// A delegated handler scoped to the component works regardless of when the markup arrives.
$(document).on('change', '.brand-groups-inventory-component .brand-group-type-filter', function () {
  $(this).closest('form').submit();
});

// Show an explanation when the keyword filter hides every card. Without this, searching a brand
// that belongs to no group just empties the page, which reads as a broken filter.
//
// The shared handler in global.js does the hiding; this only reports on the result. Both are
// delegated on document, so jQuery would run them in binding order - and which binds first depends
// on whether this bundle executes before global.js's document-ready callback. Deferring to the next
// task sidesteps that entirely: by then the filtering for this keystroke has finished either way.
$(document).on('input', '.brand-groups-inventory-component .keyword-filter', function () {
  const component = $(this).closest('.brand-groups-inventory-component');

  setTimeout(function () {
    const cards = component.find('.keyword-item');
    const noneVisible = cards.length > 0 && cards.not('.d-none').length === 0;

    component.find('.no-keyword-matches').prop('hidden', !noneVisible);
  }, 0);
});
